// extracted by mini-css-extract-plugin
module.exports = {"hand":"_0fce717cdb--hand--J2uiq","animated":"_0fce717cdb--animated--Wb7h1","shake_hand":"_0fce717cdb--shake_hand--wlR_p"};